import ListField from './ListField'
const Skill = props => (
   <ListField
      {...props}
      label="Skills"
      fieldKey="skills"
      placeholder="e.g. React, Node.js…"
   />
)
export default Skill
